import React from 'react';
import Navbar from '../../components/navbar/navbar';
import Footer from '../../components/footer';
import EligibilityCalculator from '../../components/eligibility-calculator';

const EligibilityCalculatorPage: React.FC = () => {
    return (
        <div className="bg-slate-50 min-h-screen">
            <Navbar transparent={false} />
            
            {/* Page Header */}
            <div className="relative pt-6 md:pt-10 pb-6 md:pb-10 bg-white border-b border-slate-100 overflow-hidden">
                <div className="absolute top-0 left-0 w-full h-full opacity-5">
                    <div className="absolute top-10 left-10 w-64 h-64 bg-[#001b4a] rounded-full blur-3xl"></div>
                    <div className="absolute bottom-10 right-10 w-96 h-96 bg-[#f1ae24] rounded-full blur-3xl"></div>
                </div>
                
                <div className="container px-6 relative z-10">
                    <div className="max-w-4xl">
                        <nav className="flex items-center gap-2 text-slate-400 text-xs font-medium tracking-wide mb-1 md:mb-2">
                            <span>Tools</span>
                            <i className="fa-solid fa-chevron-right text-[8px]"></i>
                            <span className="text-[#001b4a]">Eligibility Calculator</span>
                        </nav>
                        
                        <h1 className="text-3xl md:text-5xl font-bold text-[#001b4a] mb-2 md:mb-4 leading-tight">
                            Loan <span className="text-[#f1ae24]">Eligibility</span> Checker
                        </h1>
                        <p className="text-slate-500 text-base font-medium max-w-2xl leading-relaxed">
                            Verify your true borrowing power before you hunt for your dream home. Our advanced algorithm uses banking standards to determine your maximum home loan potential.
                        </p>
                    </div>
                </div>
            </div>

            {/* Calculator Section */}
            <section className="py-6 md:py-8 -mt-10 relative z-20">
                <div className="container px-6">
                    <div className="max-w-6xl mx-auto">
                        <EligibilityCalculator initialSalary={100000} />
                        
                        {/* Summary / Educational Content Below Tool */}
                        <div className="mt-8 md:mt-12 grid grid-cols-1 md:grid-cols-3 gap-8">
                            <div className="bg-white p-6 rounded-2xl shadow-sm border border-slate-100">
                                <div className="w-10 h-10 rounded-xl bg-slate-50 flex items-center justify-center text-[#001b4a] mb-4">
                                    <i className="fa-solid fa-bolt text-lg"></i>
                                </div>
                                <h5 className="font-bold text-slate-900 text-sm mb-3">Boost Eligibility</h5>
                                <p className="text-slate-500 text-sm leading-relaxed">
                                    Clear existing debts like credit card dues or personal loans before applying. Adding a co-applicant with a steady income can also significantly increase your loan capacity.
                                </p>
                            </div>
                            <div className="bg-white p-6 rounded-2xl shadow-sm border border-slate-100">
                                <div className="w-10 h-10 rounded-xl bg-slate-50 flex items-center justify-center text-[#001b4a] mb-4">
                                    <i className="fa-solid fa-landmark text-lg"></i>
                                </div>
                                <h5 className="font-bold text-slate-900 text-sm mb-3">Bank Criteria</h5>
                                <p className="text-slate-500 text-sm leading-relaxed">
                                    Banks look at your FOIR (Fixed Obligation to Income Ratio). Typically, they ensure that your total EMIs don't exceed 50% of your net monthly take-home salary.
                                </p>
                            </div>
                            <div className="bg-white p-6 rounded-2xl shadow-sm border border-slate-100">
                                <div className="w-10 h-10 rounded-xl bg-slate-50 flex items-center justify-center text-[#001b4a] mb-4">
                                    <i className="fa-solid fa-calendar-check text-lg"></i>
                                </div>
                                <h5 className="font-bold text-slate-900 text-sm mb-3">Why it matters?</h5>
                                <p className="text-slate-500 text-sm leading-relaxed">
                                    Knowing your eligibility helps you filter properties that fit your budget, preventing disappointments and ensuring a faster, smoother loan approval process.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            
            <Footer />
        </div>
    );
};

export default EligibilityCalculatorPage;
